import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Radio, Space, Button } from 'antd';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { css } from '@emotion/react';
import { InfoModal } from 'vl-common/src/components/Modals';
import { useSessionOutcomeMutation } from '@hooks/useSessionOutcomeMutation';
import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';

export const PriorityFormItem = () => {
  const { t } = useTranslation('common');
  const { appointment } = useSessionAppointment();

  const [waitList, setWaitList] = useState(false);

  const { data: appointmentsMeta } = useAppointmentMeta();

  const { mutate } = useSessionOutcomeMutation();

  const disabled = appointment?.appointment_completed || appointment?.read_only;

  if (!appointmentsMeta?.appt_priorities) return null;

  return (
    <>
      <div>
        {appointment.patient_client_code === 'HELENA' ? t('Medico-legal review') : t('Waiting list Priority')}
        {appointment.patient_client_code !== 'HELENA' && (
          <Button
            disabled={appointment.read_only}
            data-testid="show-wait-list-definition-button"
            onClick={() => setWaitList(true)}
            css={{ fontSize: 'inherit' }}
            type="link"
          >
            <AiOutlineInfoCircle css={{ verticalAlign: 'middle', fontSize: 20 }} />
            &nbsp;Definition
          </Button>
        )}
      </div>

      <Form.Item name="Priority">
        <Radio.Group
          disabled={disabled}
          onChange={(e) => {
            mutate({
              priority: e.target.value
            });
          }}
        >
          <Space size="large">
            {appointmentsMeta.appt_priorities.map((item) => (
              <Radio.Button key={item.appt_pri_no} value={item.appt_pri_no} data-testid="priority-radio-button">
                {item.appt_pri_desc}
              </Radio.Button>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>

      <InfoModal
        open={waitList}
        onCancel={() => setWaitList(false)}
        onOk={() => setWaitList(false)}
        title="Waiting list priotitisation"
      >
        <table
          className="wait-list-table"
          css={css`
            margin: auto;

            tr:nth-child(even) {
              background: var(--productIron);
            }

            tr:nth-child(odd) {
              background: #fff;
            }

            td {
              border: 1px solid var(--productGray);
              padding: 10px 20px;
            }
          `}
        >
          <tbody>
            <tr>
              <td>{t('Urgent')}</td>
              <td>{t('P1')}</td>
            </tr>
            <tr>
              <td>&lt; 1 month</td>
              <td>{t('P2')}</td>
            </tr>
            <tr>
              <td>&lt; 3 month</td>
              <td>{t('P3')}</td>
            </tr>
            <tr>
              <td>
                &gt; 3 month
                <br />
                {t('Delay 3 months possible')}
              </td>
              <td>{t('P4')}</td>
            </tr>
            <tr>
              <td>
                {t('Patient wishes to postpone surgery')}
                <br />
                {t('because of COVID-19 concerns**')}
              </td>
              <td>{t('P5')}</td>
            </tr>
            <tr>
              <td>
                {t('Patient wishes to postpone surgery')}
                <br />
                {t('due to non COVID-19 concerns**')}
              </td>
              <td>{t('P6')}</td>
            </tr>
          </tbody>
        </table>
      </InfoModal>
    </>
  );
};
